import { TscEmployeeEffects } from './effects.employees';
import { TscAdminRegionEffects } from './effects.region';
import { TscStatusHubEffects } from './effects.status-hub';
import { TscWorkshopEffects } from './effects.workshops';

export * as TscAdminActions from './actions';
export * as TscAdminReducer from './reducer';
export * as TscAdminSelectors from './selectors';

export const TSC_ADMIN_EFFECTS: any[] = [TscStatusHubEffects, TscAdminRegionEffects, TscEmployeeEffects, TscWorkshopEffects];
